import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-ai-popular-collections',
  templateUrl: './ai-popular-collections.component.html',
  styleUrls: ['./ai-popular-collections.component.scss']
})
export class AIPopularCollectionsComponent implements OnInit {
  slidesData: any = [];
  popularData:any = [];

  constructor(private dataService: DataService,) { }

  async ngOnInit() {
    (await this.dataService.getPopularBannerService()).subscribe((singleservice) => {
      this.slidesData = [];
      this.slidesData = singleservice;
      //console.log(this.slidesData)
    });
    
    (await this.dataService.getCollectionService()).subscribe(
      (singleservice) => {
        this.popularData = [];

        this.popularData = singleservice.filter((data)=>{
          return data["isFeatured"] && data["isAICollection"]
        })

        //console.log(this.popularData);
      }
    );
  }

}
